import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import cn from 'classnames';
import ErrorInput from '../InputError/InputError';
import styles from './TextInput.module.scss';
import InputLabel from '../InputLabel/InputLabel';
import Link from '../../Link/Link';
const TextInput = ({ className, label, field, form, placeholder, disabled, type = 'text', linkText, defaultValue, onInput, readOnly }) => {
    const [focus, setFocus] = useState(!!field.value);
    useEffect(() => {
        if (field.value !== '') {
            setFocus(true);
        }
    }, [field.value]);
    return (_jsxs("div", Object.assign({ className: cn(styles.wrapper, className) }, { children: [_jsxs("div", Object.assign({ className: cn(styles.element, focus && styles['isFocused'], readOnly && styles['isReadOnly'], form.touched[field.name] && form.errors[field.name] && styles['isActive']) }, { children: [_jsxs("div", Object.assign({ className: 'd-flex align-content-center justify-content-between' }, { children: [label && _jsx(InputLabel, { children: label }), linkText && _jsx(Link, { size: 1, text: linkText })] })), _jsx("input", { onBlur: (e) => {
                            field.onBlur(e);
                            field.value === '' && setFocus(false);
                        }, name: field.name, onChange: field.onChange, onInput: onInput, onFocus: () => setFocus(true), type: type, readOnly: readOnly, className: label ? styles['isLabel'] : '', placeholder: placeholder, disabled: disabled, defaultValue: defaultValue })] })), form.touched[field.name] && form.errors[field.name] && (_jsx(ErrorInput, { errors: form.errors, inputName: field.name }))] })));
};
export default TextInput;
